<template>
  <div class="page-container">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="登录日志" name="login">
        <!-- 左按钮 + 右查询 -->
        <div class="toolbar">
          <div class="toolbar-left">
            <el-button type="danger" :icon="Delete" @click="cleanLogin" :disabled="loginData.total === 0">清理 90 天前</el-button>
          </div>
          <div class="toolbar-right">
            <el-input v-model="loginQuery.keyword" clearable placeholder="账号 / 姓名" style="width:180px" @keyup.enter="loadLogin" />
            <el-select v-model="loginQuery.status" clearable placeholder="状态" style="width:120px">
              <el-option label="成功" :value="1" />
              <el-option label="失败" :value="0" />
            </el-select>
            <el-date-picker v-model="loginQuery.range" type="datetimerange" start-placeholder="开始时间" end-placeholder="结束时间" value-format="YYYY-MM-DD HH:mm:ss" range-separator="至" style="width:340px" />
            <el-button type="primary" :icon="Search" @click="loadLogin">查询</el-button>
            <el-button :icon="Refresh" @click="resetLogin">重置</el-button>
          </div>
        </div>

        <el-table :data="loginData.list" border stripe v-loading="loginLoading">
          <el-table-column prop="id" label="ID" width="70" />
          <el-table-column prop="username" label="账号" width="130" />
          <el-table-column prop="realName" label="姓名" width="110" />
          <el-table-column prop="loginIp" label="IP" width="140" />
          <el-table-column label="状态" width="80">
            <template #default="{ row }">
              <el-tag :type="row.status === 1 ? 'success' : 'danger'" size="small">
                {{ row.status === 1 ? '成功' : '失败' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="browser" label="浏览器" width="100" />
          <el-table-column prop="os" label="系统" width="110" />
          <el-table-column prop="failReason" label="失败原因" min-width="140" show-overflow-tooltip />
          <el-table-column prop="loginTime" label="登录时间" width="170" />
        </el-table>

        <MyPager :total="loginData.total" v-model:page="loginQuery.page" v-model:size="loginQuery.size" @change="loadLogin" />
      </el-tab-pane>

      <el-tab-pane label="操作日志" name="op">
        <div class="toolbar">
          <div class="toolbar-left">
            <el-button type="danger" :icon="Delete" @click="cleanOp" :disabled="opData.total === 0">清理 90 天前</el-button>
          </div>
          <div class="toolbar-right">
            <el-select v-model="opQuery.module" clearable placeholder="业务模块" style="width:140px">
              <el-option v-for="m in opOptions.modules" :key="m.module" :label="m.module" :value="m.module" />
            </el-select>
            <el-select v-model="opQuery.action" clearable placeholder="操作类型" style="width:120px">
              <el-option v-for="a in opOptions.actions" :key="a.action" :label="opActionLabel(a.action)" :value="a.action" />
            </el-select>
            <el-input v-model="opQuery.keyword" clearable placeholder="描述 / 操作人" style="width:170px" @keyup.enter="loadOp" />
            <el-select v-model="opQuery.status" clearable placeholder="状态" style="width:90px">
              <el-option label="成功" :value="1" />
              <el-option label="失败" :value="0" />
            </el-select>
            <el-date-picker v-model="opQuery.range" type="datetimerange" start-placeholder="开始时间" end-placeholder="结束时间" value-format="YYYY-MM-DD HH:mm:ss" range-separator="至" style="width:320px" />
            <el-button type="primary" :icon="Search" @click="loadOp">查询</el-button>
            <el-button :icon="Refresh" @click="resetOp">重置</el-button>
          </div>
        </div>

        <el-table :data="opData.list" border stripe v-loading="opLoading">
          <el-table-column prop="id" label="ID" width="60" />
          <el-table-column prop="module" label="模块" width="110" />
          <el-table-column label="操作" width="80">
            <template #default="{ row }">
              <el-tag size="small">{{ opActionLabel(row.action) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="操作描述" min-width="200" show-overflow-tooltip />
          <el-table-column prop="targetId" label="对象ID" width="90" />
          <el-table-column prop="operatorName" label="操作人" width="100" />
          <el-table-column prop="ip" label="IP" width="130" />
          <el-table-column prop="requestMethod" label="方法" width="70" />
          <el-table-column prop="requestUri" label="URI" min-width="140" show-overflow-tooltip />
          <el-table-column label="状态" width="70">
            <template #default="{ row }">
              <el-tag :type="row.status === 1 ? 'success' : 'danger'" size="small">
                {{ row.status === 1 ? '成功' : '失败' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="costMs" label="耗时(ms)" width="80" align="right" />
          <el-table-column prop="createTime" label="时间" width="165" />
          <el-table-column label="操作" width="80" fixed="right">
            <template #default="{ row }">
              <el-button link type="primary" size="small" @click="showDetail(row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>

        <MyPager :total="opData.total" v-model:page="opQuery.page" v-model:size="opQuery.size" @change="loadOp" />
      </el-tab-pane>
    </el-tabs>

    <!-- 操作详情弹窗 -->
    <el-dialog v-model="detailVisible" title="操作日志详情" width="680px" destroy-on-close>
      <template v-if="detailRow">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="ID">{{ detailRow.id }}</el-descriptions-item>
          <el-descriptions-item label="模块">{{ detailRow.module }}</el-descriptions-item>
          <el-descriptions-item label="操作">{{ opActionLabel(detailRow.action) }}</el-descriptions-item>
          <el-descriptions-item label="操作对象">{{ detailRow.targetType || '-' }} / ID: {{ detailRow.targetId || '-' }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag :type="detailRow.status === 1 ? 'success' : 'danger'" size="small">
              {{ detailRow.status === 1 ? '成功' : '失败' }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="耗时">{{ detailRow.costMs }} ms</el-descriptions-item>
          <el-descriptions-item label="操作人">{{ detailRow.operatorName }} ({{ detailRow.operatorId || '-' }})</el-descriptions-item>
          <el-descriptions-item label="IP">{{ detailRow.ip }}</el-descriptions-item>
          <el-descriptions-item label="请求方法">{{ detailRow.requestMethod }}</el-descriptions-item>
          <el-descriptions-item label="请求 URI" :span="2">{{ detailRow.requestUri }}</el-descriptions-item>
          <el-descriptions-item label="操作描述" :span="2">{{ detailRow.description }}</el-descriptions-item>
          <el-descriptions-item v-if="detailRow.errorMsg" label="错误信息" :span="2">
            <span style="color:#f56c6c">{{ detailRow.errorMsg }}</span>
          </el-descriptions-item>
        </el-descriptions>

        <div style="margin-top:16px">
          <div class="detail-section-title">请求参数 & 返回结果</div>
          <pre class="json-block">{{ formatDetails(detailRow.details) }}</pre>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Search, Refresh, Delete } from '@element-plus/icons-vue'
import request from '../utils/request'
import MyPager from '../components/MyPager.vue'

const activeTab = ref('login')

// ========== 登录日志 ==========
const loginQuery = reactive({ page: 1, size: 20, keyword: '', status: null, range: null })
const loginData = reactive({ total: 0, list: [] })
const loginLoading = ref(false)

function loadLogin() {
  loginLoading.value = true
  const p = { page: loginQuery.page, size: loginQuery.size }
  if (loginQuery.keyword) p.keyword = loginQuery.keyword
  if (loginQuery.status != null) p.status = loginQuery.status
  if (loginQuery.range && loginQuery.range.length === 2) {
    p.startTime = loginQuery.range[0]; p.endTime = loginQuery.range[1]
  }
  request.get('/log/login-list', { params: p }).then(res => {
    Object.assign(loginData, res.data || { total: 0, list: [] })
  }).catch(() => {}).finally(() => { loginLoading.value = false })
}
function resetLogin() {
  loginQuery.keyword = ''; loginQuery.status = null; loginQuery.range = null
  loginQuery.page = 1; loadLogin()
}
function cleanLogin() {
  ElMessageBox.confirm('确定清理 90 天前的登录日志？此操作不可恢复', '清理确认', { type: 'warning' })
    .then(() => {
      const before = new Date(Date.now() - 90 * 86400000).toISOString().replace('T', ' ').substring(0, 19)
      request.delete('/log/login-clean', { params: { beforeTime: before } }).then(res => {
        ElMessage.success(`已清理 ${res.data.deleted} 条`)
        loadLogin()
      }).catch(() => {})
    }).catch(() => {})
}

// ========== 操作日志 ==========
const opQuery = reactive({ page: 1, size: 20, module: '', action: '', keyword: '', status: null, range: null })
const opData = reactive({ total: 0, list: [] })
const opLoading = ref(false)
const opOptions = reactive({ modules: [], actions: [] })

const opActionLabelMap = {
  create: '新增', save: '保存', update: '修改', delete: '删除', handle: '处理',
  export: '导出', import: '导入', login: '登录', approve: '审批', assign: '派单',
  finish: '完成', complete: '完成', reject: '驳回', close: '关闭',
  start: '启动', stop: '停止', upload: '上传', download: '下载',
  batch: '批量', clean: '清理', run: '执行', reset: '重置', menu_assign: '分配权限'
}
function opActionLabel(a) { return opActionLabelMap[a] || a }

function loadOp() {
  opLoading.value = true
  const p = { page: opQuery.page, size: opQuery.size }
  if (opQuery.module) p.module = opQuery.module
  if (opQuery.action) p.action = opQuery.action
  if (opQuery.keyword) p.keyword = opQuery.keyword
  if (opQuery.status != null) p.status = opQuery.status
  if (opQuery.range && opQuery.range.length === 2) {
    p.startTime = opQuery.range[0]; p.endTime = opQuery.range[1]
  }
  request.get('/log/op-list', { params: p }).then(res => {
    Object.assign(opData, res.data || { total: 0, list: [] })
  }).catch(() => {}).finally(() => { opLoading.value = false })
}
function loadOpOptions() {
  request.get('/log/op-options').then(res => {
    if (res.data) Object.assign(opOptions, res.data)
  }).catch(() => {})
}
function resetOp() {
  opQuery.module = ''; opQuery.action = ''; opQuery.keyword = ''
  opQuery.status = null; opQuery.range = null; opQuery.page = 1; loadOp()
}
function cleanOp() {
  ElMessageBox.confirm('确定清理 90 天前的操作日志？此操作不可恢复', '清理确认', { type: 'warning' })
    .then(() => {
      const before = new Date(Date.now() - 90 * 86400000).toISOString().replace('T', ' ').substring(0, 19)
      request.delete('/log/op-clean', { params: { beforeTime: before } }).then(res => {
        ElMessage.success(`已清理 ${res.data.deleted} 条`)
        loadOp()
      }).catch(() => {})
    }).catch(() => {})
}

// ========== 详情 ==========
const detailVisible = ref(false)
const detailRow = ref(null)
function showDetail(row) {
  detailRow.value = row
  detailVisible.value = true
}
function formatDetails(d) {
  if (!d) return '（无）'
  try {
    const obj = typeof d === 'string' ? JSON.parse(d) : d
    return JSON.stringify(obj, null, 2)
  } catch {
    return d
  }
}

// ========== 生命周期 ==========
onMounted(() => { loadLogin(); loadOpOptions() })
watch(activeTab, v => { if (v === 'op') loadOp() })
</script>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.toolbar-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
.detail-section-title {
  font-weight: 600;
  margin-bottom: 8px;
  color: #606266;
  font-size: 14px;
}
.json-block {
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 12px;
  max-height: 400px;
  overflow: auto;
  font-size: 12px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-all;
  color: #303133;
  margin: 0;
}
</style>
